//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Emitter from '@/mixins/emitter';

export default {
  name: 'DpDropdownItem',
  mixins: [Emitter],
  props: {
    to: { type: Object, default: () => null },
    disabled: { type: Boolean, default: false },
    isSeparator: { type: Boolean, default: false },
    isDelete: { type: Boolean, default: false },
    icon: { type: String, default: null },
  },
  computed: {
    is() {
      if (this.to) {
        return 'router-link';
      }
      if (this.isSeparator) {
        return 'hr';
      }
      return 'a';
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
      this.dispatch('DpDropdown', 'handleClick', this);
    },
  },
};
